import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

// کامپوننت‌های لندینگ
import HealthSensors from "../components/landing/HealthSensors/index.tsx";
import PersonaGrid from "../components/landing/PersonaGrid";
import FinalCTA from "../components/landing/FinalCTA";
import ComparisonSlider from "@/components/landing/ComparisonSlider";
import Testimonials from "@/components/Testimonials";
import { useBandTestimonials } from "../testimonialsData/bandTestimonials";
import HeroSection from "../components/landing/SmartBandHeroSection";
import CuratedProductShowcase from "../components/landing/CuratedProductShowcase";
import EnhancedFAQ from "../components/landing/FAQSection";
import SmartBandHardwareFeatures from "../components/landing/deta-HardwareFeatures/SmartBandHardwareFeatures";
import LifestyleUseCasesSmartBand from "../components/landing/deta-LifestyleUseCases/LifestyleUseCasesSmartBand";
import { motion } from "framer-motion";
import SmartBandComparison from "../components/landing/SmartBandComparison";
import { bandFaqs } from "../components/landing/deta-FAQ/bandFaqs";
import AIAssistantSection from "../components/landing/AIAssistantSection";
import SmartBandPainPrevention from "../components/landing/SmartBandPainPrevention";
import { Helmet } from "react-helmet-async";

const SmartBandsPage = () => {
    const productComparisonRef = useRef(null);
     const [triggerAnimation, setTriggerAnimation] = useState(0);
    const bandTestimonials = useBandTestimonials();

    // Structured Data
     const structuredData = {
         "@context": "https://schema.org",
         "@type": "Product",
         "name": "دستبند هوشمند دلبند",
         "description": "دستبند هوشمند با قابلیت‌های جامع نظارت بر سلامت و فعالیت",
         "brand": {
             "@type": "Brand",
             "name": "دلبند"
         },
         "category": "دستبند هوشمند"
     };

     const scrollToProductComparison = () => {
         if (productComparisonRef.current) {
             // تاخیر کوتاه برای انیمیشن بهتر
             setTimeout(() => {
                 (productComparisonRef.current as unknown as HTMLElement).scrollIntoView({
                     behavior: "instant", // بدون نمایش اسکرول
                     block: "start",
                 });

                 // trigger کردن انیمیشن با تغییر key
                 setTimeout(() => {
                     setTriggerAnimation((prev) => prev + 1);
                 });
             }, 300);
         }
     };

    return (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.7 }} className="overflow-x-clip">
            <Helmet>
                <title>دستبند هوشمند دلبند -پایش پیشرفته سلامت </title>
                <meta name="description" content="دستبند هوشمند دلبند با طراحی ارگونومیک و قابلیت‌های جامع نظارت بر سلامت، فعالیت‌های ورزشی و کیفیت خواب. زندگی سالم‌تر را تجربه کنید." />
                <meta name="keywords" content="دستبند هوشمند, نظارت سلامت, ردیاب فعالیت, کیفیت خواب, سلامت روزانه" />
                <link rel="canonical" href="https://delband.com/smart-bands" />
                <meta property="og:title" content="دستبند هوشمند دلبند - سلامتی در دستان شما" />
                <meta property="og:url" content="https://delband.com/smart-bands" />
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>
            <div className="bg-[#F8F9FC] relative w-full overflow-x-clip">
                <Header />
                <main className="container mx-auto px-2 pb-8 pt-26 sm:pt-24 md:pt-21 max-w-7xl overflow-x-clip">
                    <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-gradient-to-br from-[#0038A8] to-[#0072CE] rounded-full blur-[120px] opacity-25 z-0 pointer-events-none"></div>
                    <div className="absolute bottom-0 left-[-14%] w-[300px] h-[300px] bg-gray-600 rounded-full blur-[120px] opacity-15 sm:opacity-25 z-[999999] pointer-events-none"></div>

                    <HeroSection onCompareClick={scrollToProductComparison} />
                    <HealthSensors />
                    <SmartBandHardwareFeatures />
                    <AIAssistantSection />

                    <LifestyleUseCasesSmartBand />
                    {/* <BeyondHealthServices /> */}
                    <PersonaGrid />


                    <ComparisonSlider
                        productType="band"
                        leftId="EVB-E50"
                        rightId="EVB-V10"
                    />
                    
                    {/* ویترین اسلایدی ۴ محصول اختصاصی */}
                    <CuratedProductShowcase
                        productType="band"
                        onCompareClick={scrollToProductComparison}
                        titleRegular="ویترین منتخب"
                        titleHighlighted="دستبندهای هوشمند دلبند"
                        descriptionText="چهار مدل اختصاصی مهندسی‌شده برای پاسخ دقیق به نیازهای پایش سلامت، ورزش و سبک زندگی شما"
                    />
                    {/* <DataFlowInsight /> */}
                    {/* بخش مقایسه محصولات */}
                    <motion.div
                        key={triggerAnimation}
                        ref={productComparisonRef}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: false, margin: "-100px" }}
                    >
                        <SmartBandComparison />
                    </motion.div>
                    <Testimonials data={bandTestimonials} translationNamespace="bandTestimonials" />

                    <EnhancedFAQ faqs={bandFaqs} translationNamespace="bandFAQs" />
                    <FinalCTA />
                </main>
                <Footer />
            </div>
        </motion.div>
    );
};

export default SmartBandsPage;
